import Property2GridContainer from "../../../components/property/grid/Property2Grid";

const Property2Grid = () => {
  return <Property2GridContainer />;
};

export default Property2Grid;
